import { combineReducers } from 'redux';
import authenticationReducer from './AuthenticationReducers';
import profileReducer from './ProfileReducers';
import regionsReducer from './RegionsReducers';
import addressesReducer from './AddressesReducers';
import flashReducer from './FlashReducer';
import passwordReducer from './PasswordReducer';
import loyaltyReducer from './LoyaltyReducer';
import productReducer from './ProductReducer';
import trackingReducer from './TrackingReducer';
import giftCardReducer from './GiftCardReducer';
import bankReducer from './BankReducer';
import ticketReducer from './TicketReducer';
import bannerReducer from './BannerReducer';

const mainReducer = combineReducers({
  authenticationReducer,
  profileReducer,
  regionsReducer,
  loyaltyReducer,
  addressesReducer,
  flashReducer,
  passwordReducer,
  productReducer,
  trackingReducer,
  giftCardReducer,
  bankReducer,
  ticketReducer,
  bannerReducer,
});

export default mainReducer;
